
import { IRuleParemeters } from 'common/model';
import { ClientInputContentGroup, IClientEvideGroupHttp } from './common.model';

export class ClientEvideForm {

  public readonly inputContentGroups: ClientInputContentGroup[] = [];

  constructor(
    public id: number,
    public licenseId: number,
    public title: string,
    public formGuid: string,
    public projectId: number,
    public formType?: number,
    public description?: string,
    public readonly ruleParemeters?: IRuleParemeters
  ) { }

  public static fromJson(res: IClientEvideFormHttp): ClientEvideForm {
    const form = new this(
      res.id, res.licenseId, res.title, res.formGuid, res.projectId,
      res.formType, res.description, res.ruleParemeters
    );
    if (res.inputContentGroups) {
      form.inputContentGroups.push(...res.inputContentGroups.map(item => ClientInputContentGroup.fromJson(item, res.ruleParemeters)));
    }
    return form;
  }

}

export interface IClientEvideFormHttp {
  id: number;
  licenseId: number;
  projectId: number;
  projectName: string;
  title: string;
  description: string;
  formGuid: string;
  formType: number;
  formTypeName: string;
  status: number;
  statusName: string;
  inputContentGroups?: IClientEvideGroupHttp[];
  ruleParemeters: IRuleParemeters;
}